const gameLang = {
  CTR_title: [
    'CTR =SUBSCRIPTIONS（MESSENGER+EMAILl）/TOTAL IMPRESSIONS',
    '参与率= （Messenger订阅人数+邮箱订阅人数）/ 游戏总展览次数'
  ],
  REVENUE_title: [
    'REVENUE: REVENUE FROM COUPONS',
    '订单金额：游戏优惠券产生的购买'
  ],
  Are_you: [
    'Are you sure you want to delete this game?',
    '你确定删除这项游戏吗？'
  ],
  comment_row_1: [
    "Like how's the app doing so far?",
    '您好，APP使用起来流畅么？'
  ],
  comment_row_2: [
    'We work hard to keep this plan and update new features weekly.',
    '我们每周都在研究和改进APP的功能'
  ],
  comment_row_3: [
    'Hope you could drop us your feedback so we know we are on the right track!',
    '请告诉我们您的使用情况，来帮助我们完善产品的功能'
  ],
  TOTAL_IMPRESSIONS: ['IMPRESSIONS', '游戏总展示次数'],
  TOTAL_CAPTURED_EMAILS: ['EMAILS', '获取邮箱个数'],
  TOTAL_CAPTURED_MESSENGERS: ['MESSENGERS', 'Messenger订阅人数'],
  TOTAL_CTR: ['TOTAL CTR', '参与率（%）'],
  REVENUE_FROM_COUPONS: ['REVENUE', '订单金额'],
  IMPR: ['IMPR', '总展示次数'],
  SUBS: ['SUBS', '订阅人数'],
  CTR: ['CTR%', '参与率（%）'],
  DAYS: ['DAYS', '时间(天)'],
  REVENUE: ['REVENUE', '订单金额'],
  My_Games: ['My Games', '我的游戏'],
  New_Game: ['New Game', '新增游戏'],
  Enter_Game_Name: ['Enter Game Name', '输入游戏名称'],
  Comment: ['Comment', '评论'],
  DAYS_2: [' ', '天']
};
export default gameLang;
